import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledNarrowerContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: ${rem('40px')};
  padding: 5%;
  border-radius: ${rem('16px')};
  max-height: 40vh;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};

  & > *:last-child {
    margin-bottom: 0;
  }

  /* width */
  &::-webkit-scrollbar {
    width: ${rem('2px')};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.cross.grayson};
  }
`;
